export const dialogTexts = {
	faqs: {
		title: "dialog.faqs.title",
		body: "dialog.faqs.body",
	},
};
